import { useContext, useEffect } from 'react'
import { Grid } from '@mui/material'

import RightPanel from '../rightPanel';
import MonitorUsageCard from './monitorUsageCard'
import ChargeLevelCard from './chargeLevelCard'
import CarbonSavingsCard from './carbonSavingsCard'
import { DataContext } from '../../../contexts/data/dataContext'
import { analyticsPage, analyticsDomain } from '../../../services/constants'
import { sendViewAnalytics } from '../../common/util/util'

export default function Monitor() {
    const data = useContext(DataContext)

    useEffect(()=>{
        sendViewAnalytics('/rightPanel', {
                domain: analyticsDomain.monitorToday,
                name: analyticsPage.monitorToday
            })
      },[])

    return (
        <RightPanel title="Monitor">
            <Grid container direction="row" 
                    display="flex" 
                    alignContent={"center"}
                    justifyContent={"center"} 
                    pb={10}
                    >                 
                <Grid item xs={12} 
                    display="flex" 
                    alignContent={"center"}
                    justifyContent={"center"} >
                    <MonitorUsageCard 
                        id="homeUsage" 
                        monitor="home" 
                        content={data.dashboard.monitor.home}/>
                </Grid>
                <Grid item xs={12} 
                    display="flex" 
                    alignContent={"center"}
                    justifyContent={"center"}>
                    <MonitorUsageCard 
                        id="solarUtilization" 
                        monitor="solar" 
                        content={data.dashboard.monitor.solar}/>
                </Grid>
                <Grid item xs={12}
                    display="flex" 
                    alignContent={"center"}
                    justifyContent={"center"}>
                    <ChargeLevelCard id="battery" monitor="battery" 
                        content={data.dashboard.monitor.battery}/>
                </Grid>
                <Grid item xs={12} 
                    display="flex" 
                    alignContent={"center"}
                    justifyContent={"center"}>
                    <CarbonSavingsCard 
                        id="carbon" 
                        monitor="carbon" 
                        content={data.dashboard.monitor.carbon} />
                </Grid>
            </Grid>
        </RightPanel>
    )
}